import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Popover,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { onFieldsChange, getLogs } from './action';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';

class OperalogsList extends React.Component {
    constructor(props) {
        super(props);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
    }

    componentDidMount() {
        this.props.getLogs(); //查询操作日志
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(Object.assign(_obj, { page: 1, pageSize: 10 }));
    }

    handleOnFieldsChange(fields) {
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            _obj[key] = fields[key].value;
        });
        this.props.onFieldsChange(Object.assign(_obj));
    }

    handlePaginationChange(page, per_page) {
        this.props.onFieldsChange({ page: page, pageSize: per_page });
        this.props.getLogs();
    }

    render() {
        let columns = [
            {
                title: '操作用户名称',
                dataIndex: 'operator_name',
            },
            {
                title: '操作时间',
                dataIndex: 'operator_time',
                render: text => {
                    return text == 0 ? '' : moment(text * 1000).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            // {
            //     title: '操作类型',
            //     dataIndex: 'type',
            // },
            {
                title: '操作用户ip',
                dataIndex: 'ip',
            },
            {
                title: '操作描述',
                width: '60%',
                dataIndex: 'desc',
            },
            {
                title: '操作参数',
                dataIndex: 'args',
                render: (text, record) => (
                    <div>
                        <Popover content={text} title="操作参数">
                            <a>查看</a>
                        </Popover>
                    </div>
                ),
            },
        ];
        const { logs, loading, search } = this.props;
        const { total } = search;
        return (
            <div>
                <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                <Spin spinning={loading} tip="加载中">
                    <Table columns={columns} dataSource={logs} pagination={false} bordered />
                    <Pagination
                        showQuickJumper
                        showSizeChanger
                        total={total}
                        className="ant-table-pagination"
                        onChange={this.handlePaginationChange}
                        onShowSizeChange={this.handlePaginationChange}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.operaMonitor.loading.loading,
    search: state.operaMonitor.search,
    logs: state.operaMonitor.logs,
});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: search => dispatch(onFieldsChange(search)),
    getLogs: () => dispatch(getLogs()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OperalogsList);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    //查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getLogs();
    }

    render() {
        const { areas, agents } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>操作监控</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
                        <FormItem label="操作用户ID">
                            {getFieldDecorator('operator_id')(<Input style={{ width: 120 }} placeholder="" />)}
                        </FormItem>
                        <FormItem label="操作用户名称">
                            {getFieldDecorator('operator_name')(<Input style={{ width: 120 }} placeholder="" />)}
                        </FormItem>
                        <FormItem label="ip">
                            {getFieldDecorator('ip')(<Input style={{ width: 120 }} placeholder="" />)}
                        </FormItem>
                        <FormItem label="操作类型">
                            {getFieldDecorator('type')(
                                <Select allowClear placeholder="全部" style={{ width: 120 }}>
                                    <Option value="delete">Delete</Option>
                                    <Option value="modifyInsert">ModifyInsert</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem>
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                        </FormItem>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
})(Search);



// WEBPACK FOOTER //
// ./pages/monitor/operating/index.js